import { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import StartVerification from "./StartVerification"
import VerifyIdPreview from "./VerifyIdPreview";
import { useNavigate } from "react-router-dom";
import VerificationSubmitted from "./VerificationSubmitted";
import ReverifyId from "./ReverifyId";
import VerifyId from "./VerifyId";
import HostSuccess from "../../../components/Host/HostSuccess";
import { LogoutUser } from "../../../services/Firebase";
import { GetHostStatus, GetHostDocumentSignedUrl, uploadFileToSignedUrl, ApplyForHost, LogOut } from "../../../services/api";

export default function BecomeHost() {
    const [imageFile, setImageFile] = useState(null);
    const [step, setStep] = useState("VERIFY");
    const navigate = useNavigate();

    useEffect(() => {
        GetHostStatus()
            .then((res) => {
                if (res.data.status === "pending")
                    setStep("SUBMITTED");
                else if (res.data.status === "rejected")
                    setStep("REVERIFY");
                else if (res.data.status === "approved") {
                    setStep("APPROVED");
                }
            })
            .catch((err) => {
                console.log(err)
            });
    }, []);

    const OnUploadClick = (file) => {
        setImageFile(file);
        setStep("PREVIEW");
    }

    const OnContinueClick = async () => {
        const res = await GetHostDocumentSignedUrl();
        const { signedUrl, key } = res.data;

        await uploadFileToSignedUrl(signedUrl, imageFile);

        await ApplyForHost({
            imageUrl: key
        });

        setStep("SUBMITTED")
    }

    const OnLogoutClick = async () => {
        try {
            await LogOut();
            await LogoutUser();
        } catch (error) {
            console.log(error);
        }
        navigate("/")
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black">

            {/* Close Button */}
            <button
                onClick={() => navigate(-1)}
                className="absolute top-6 right-6 z-50 text-white text-3xl"
            >
                <IoClose />
            </button>

            {step === "VERIFY" && (
                <VerifyId onStartVerification={() => setStep("START")} />
            )}

            {step === "START" && (
                <StartVerification onUpload={OnUploadClick} />
            )}

            {step === "PREVIEW" && (
                <VerifyIdPreview
                    imageFile={imageFile}
                    onReplace={setImageFile}
                    onContinue={OnContinueClick}
                />
            )}

            {step === "SUBMITTED" && (
                <VerificationSubmitted />
            )}

            {step === "REVERIFY" && (
                <ReverifyId onVerifyAgain={() => setStep("VERIFY")} />
            )}

            {step === "APPROVED" && (
                <HostSuccess onClose={OnLogoutClick} />
            )}

        </div>
    );
}